<template>
	<div class="breadcrumb">
		<div class="breadcrumb-back-wrapper pa-2 mb-2" v-if="prev && false">
			<router-link
				:to="{ name: prev.to.name, params: prev.to.params }"
				:exact="true"
				class="breadcrumb-back"
			>
				<app-icon
					icon="fa-chevron-left"
					size="x-small"
					class="mr-2"
				/>
				<span>Back</span>
			</router-link>
		</div>
		<span v-for="(item, i) in items" :key="`item-${i}`">
			<router-link
				:to="{ name: item.to.name, params: item.to.params, query: item.to.query }"
				:exact="true"
				class="breadcrumb-link"
			>{{ item.text }}</router-link>
			<span v-if="i < items.length - 1" class="breadcrumb-delimiter">{{ delimiter }}</span>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		items: Array,
		delimiter: {
			type: String,
			default: '>',
		},
	},
	computed: {
		prev() {
			if (this.items.length <= 1) { return null }
			return this.items[this.items.length - 2]
		},
	},
}
</script>
<style scoped>
	.breadcrumb-back-wrapper {
		background: white;
		margin-top: -24px;
		margin-left: -24px;
		margin-right: -24px;
	}
	.breadcrumb-back {
		text-decoration: none;
		color: inherit;
	}

	.breadcrumb-back .v-icon {
		line-height: 18px;
	}

	.breadcrumb-link {
		text-decoration: none;
	}

	.breadcrumb-link.router-link-active {
		color: gray;
		cursor: default;
	}

	span.breadcrumb-delimiter {
		margin-left: 8px;
		margin-right: 8px;
		color: lightgray;
	}
</style>
